import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { RemoveEmailCycleRecipientRPC } from "./removeEmailCycleRecipientRPC";

export class RemoveEmailCycleRecipientRPCClientImpl extends RemoveEmailCycleRecipientRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: RemoveEmailCycleRecipientRPC.Request): Promise<LeoRPCResult<RemoveEmailCycleRecipientRPC.Response, RemoveEmailCycleRecipientRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/RemoveEmailCycleRecipient",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      RemoveEmailCycleRecipientRPC.ResponseDTO,
      RemoveEmailCycleRecipientRPC.Errors.ErrorsDTO,
      RemoveEmailCycleRecipientRPC.Response,
      RemoveEmailCycleRecipientRPC.Errors.Errors
    >(
      response,
      "email-cycle/RemoveEmailCycleRecipient",
      RemoveEmailCycleRecipientRPC.Response.fromDTO,
      RemoveEmailCycleRecipientRPC.Errors.fromDTO
    );
  }
}
